import { mutationOptions } from '@tanstack/react-query'
import getApiResponseData from '@utils/get-api-response-data'

import { api } from '../api/api'
import { type RequestApi } from '../api/types'
import { key } from './key'

export const createRequestMutation = () =>
  mutationOptions({
    mutationKey: key('create-request'),
    mutationFn: async (request: RequestApi.SaveRequest) => {
      const { data } = await api.create(request)
      const createdRequest = getApiResponseData(data)?.request

      if (!createdRequest) {
        throw new Error('fulfillment request create returned no request')
      }

      return createdRequest
    },
    retry: false,
  })
